import Header from "../../components/Header/Header";
import { Observer } from "mobx-react";
import BlueButton from "../../components/Reports/BlueButton";
import RadioGroup from "../../components/Reports/RadioGroup";
import {
  BILLS,
  reportTypeBillsData,
  segmentBillsData,
  timePeriodBillsData,
  REPORTS_PAGE,
  oneDayDif,
} from "../../utils/constants";
import { useEffect, useState } from "react";
import DatePicker2 from "../../components/Reports/DatePicker2";
import ApplyFilter from "../../components/Reports/ApplyFilter";
import unsortedIcon from "../../assets/images/png/upDown.png";
import sortedIcon from "../../assets/images/png/sortedIcon.png";
import sortedAtoz from "../../assets/images/png/descSortIcon.png";
import noData from "../../assets/images/svg/noData.svg";
import Table from "../../components/Table2";
import EmptyDerivatives from "../../components/EmptyDerivaties/EmptyDerivaties";
import {
  convertDateToObj,
  getAsOfDate,
  getDecodedToken,
  getDisplayDate,
  logEvents,
  padNumber,
  trackEventWithScreen,
} from "../../utils/functions";
import { observer } from "mobx-react-lite";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";
import loaderGIF from "../../assets/images/gifs/loaderGIF.gif";
import AuthStore from "../../store/AuthStore";
import UserStore from "../../store/UserStore";
import PerformanceStore from "../../store/PerformanceStore";
import ReportsStore from "../../store/ReportsStore";
import { getCookie, setCookie } from "../../utils/cookie";
//import OverflowingText from "../../components/OverflowingText/OverflowingText";
import PageTitle from "../../components/PageTitle/PageTitle";
import PageHeading from "../../components/PageHeading/PageHeading";
import DropdownWithOptions from "../../components/Reports/UnrealisedGLReport/DropdownWithOptions";

const BillsContractNotes = () => {
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [timePeriod, setTimePeriod] = useState("this_week");
  //const [allAccountsMenuOpen, setAllAccountsMenuOpen] = useState(false);
  const [datePickerModalOpen, setDatePickerModalOpen] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [initialFromDate, setInitialFromDate] = useState(null);
  const [initialToDate, setInitialToDate] = useState(null);
  const [resetedFromDate, setResetedFromDate] = useState(null);
  const [resetedToDate, setResetedToDate] = useState(null);
  const [vertualRows, setVertualRows] = useState([]);
  const [filteredColumn, setFilteredColumn] = useState("file_Date");
  const [isFilterAscending, setIsFilterAscending] = useState(false);
  const [userAccounts, setUserAccounts] = useState([
    ...ReportsStore.usersAccounts,
  ]);

  const accounts = ReportsStore.usersAccounts;
  const contractnBillData = ReportsStore.contractnBillData;
  const userHydrated = UserStore.isHydrated;

  const handleTimePeriodChange = (selectedTimePeriod) => {
    setTimePeriod(selectedTimePeriod);
  };
  const handleReportTypeChange = (selectedReportType) => {
    ReportsStore.setReportType(selectedReportType);
  };
  const handleSegmentChange = (selectedSegment) => {
    ReportsStore.setSegment(selectedSegment);
  };

  const instrumentNameCellRenderer = (_, data, key, index) => {
    if (key === "file_Date") {
      const handleCheckboxChange = (data, idx) => {
        ReportsStore.setSingleUserTrueFalse(
          data.id,
          data.isChecked,
          "isChecked",
        );
      };
      return (
        <div className="common_cell" style={{ fontFamily: "Encode Sans" }}>
          <input
            checked={data?.isChecked}
            name={key}
            onChange={() => handleCheckboxChange(data, index)}
            className="checkbox"
            type="checkbox"
          />
          {getDisplayDate(data[key])}
        </div>
      );
    }
    if (key === "segment") {
      return (
        <div
          className="common_cell segment_column"
          style={{ fontFamily: "Encode Sans" }}
        >
          {data[key]}
        </div>
      );
    }
    return <div className="common_cell">{data[key]}</div>;
  };

  const DateHeaderRenderer = ({ label, key, sortable, width, classn }) => {
    const handleCheckboxChange = (isChecked) => {
      setIsAllChecked((prev) => !prev);
      ReportsStore.setAllUserSetTrueFalse(isChecked);
    };
    return (
      <th
        className={classn && classn}
        style={{ width: width }}
        aria-sort={
          filteredColumn === key
            ? !isFilterAscending
              ? "Ascending"
              : "Descending"
            : undefined
        }
      >
        <div
          className={
            sortable
              ? "header_cell cursor blueTextColor"
              : "header_cell blueTextColor"
          }
        >
          <input
            checked={isAllChecked}
            name={key}
            onChange={() => handleCheckboxChange(isAllChecked)}
            className="checkbox"
            type="checkbox"
          />
          <button
            onClick={() => handleSort(key)}
            className="header-checkbox-and-button"
          >
            <p>{label}</p>
            <div
              aria-hidden={true}
              className="accordion_table_header_child_icon"
            >
              <img
                src={
                  isFilterAscending && filteredColumn === key
                    ? sortedIcon
                    : !isFilterAscending && filteredColumn === key
                      ? sortedAtoz
                      : filteredColumn !== key
                        ? unsortedIcon
                        : unsortedIcon
                }
                alt="sort"
              />
            </div>
          </button>
        </div>
      </th>
    );
  };

  const ActionCellRenderer = (_, data, key) => {
    const sendData = data[key].replace(/\\/g, "\\\\");
    return (
      <div className="action_cell">
        <button onClick={() => ReportsStore.pdfDownloadForBills(sendData)}>
          Download
        </button>
      </div>
    );
  };

  const columns2 = [
    {
      label: "Date",
      key: "file_Date",
      sortable: true,
      cellRenderer: instrumentNameCellRenderer,
      customHeaderRenderer: DateHeaderRenderer,
      width: "65%",
    },
    {
      label: "Segment",
      key: "segment",
      sortable: true,
      cellRenderer: instrumentNameCellRenderer,
    },
    {
      label: "Action",
      key: "file_Path",
      sortable: false,
      cellRenderer: ActionCellRenderer,
    },
  ];

  const onApplyFilter = () => {
    setIsAllChecked(false);
    ReportsStore.updateTableDataLoader(true);
    setFilteredColumn("file_Date");
    ReportsStore.applyBillsFilter(
      `${fromDate.date}/${fromDate?.month}/${fromDate.year}`,
      `${toDate.date}/${toDate?.month}/${toDate.year}`,
    );
  };
  const onClearFilter = () => {
    ReportsStore.setSelectedAccount(userAccounts[0]);
    setTimePeriod((prevState) => "this_week");
    ReportsStore.setReportType("1");
    ReportsStore.setSegment("0");
    const storeFromDate = ReportsStore.billfromDate;
    const storeToDate = ReportsStore.billtoDate;
    setTimeout(() => {
      ReportsStore.applyBillsFilter(
        `${storeFromDate?.date}/${storeFromDate?.month}/${storeFromDate?.year}`,
        `${storeToDate?.date}/${storeToDate?.month}/${storeToDate?.year}`,
      );
    }, 1000);
  };

  const handleAllSelection = () => {
    for (let i = 0; i < ReportsStore.contractnBillData.length; i++) {
      if (ReportsStore.contractnBillData?.[i]?.isChecked) {
        const sendData = ReportsStore.contractnBillData?.[
          i
        ]?.file_Path?.replace(/\\/g, "\\\\");

        ReportsStore.pdfDownloadForBills(sendData);
      }
    }
  };

  const handleSort = (key) => {
    setIsFilterAscending(key === filteredColumn ? !isFilterAscending : false);
    setFilteredColumn(key);
  };

  useEffect(() => {
    setVertualRows(ReportsStore.contractnBillData);
  }, [
    contractnBillData,
    //ReportsStore.contractnBillData
  ]);

  useEffect(() => {
    let rowData = ReportsStore.contractnBillData;
    if (rowData) {
      if (filteredColumn === "segment" && !isFilterAscending) {
        ReportsStore.updateBillsNContractsData(
          [...rowData]?.sort((a, b) =>
            b?.[filteredColumn].localeCompare(a?.[filteredColumn]),
          ),
        );
      }
      if (filteredColumn === "segment" && isFilterAscending) {
        ReportsStore.updateBillsNContractsData(
          [...rowData]
            ?.sort((a, b) =>
              b?.[filteredColumn].localeCompare(a?.[filteredColumn]),
            )
            .reverse(),
        );
      }

      if (filteredColumn === "file_Date" && isFilterAscending) {
        ReportsStore.updateBillsNContractsData(
          [...rowData]?.sort((a, b) => {
            let aa = a?.[filteredColumn]?.split("-")?.join();
            let bb = b?.[filteredColumn]?.split("-")?.join();

            return aa < bb ? -1 : aa > bb ? 1 : 0;
          }),
        );
      }
      if (filteredColumn === "file_Date" && !isFilterAscending) {
        ReportsStore.updateBillsNContractsData(
          [...rowData]
            ?.sort((a, b) => {
              let aa = a?.[filteredColumn]?.split("-")?.join();
              let bb = b?.[filteredColumn]?.split("-")?.join();
              return aa < bb ? -1 : aa > bb ? 1 : 0;
            })
            .reverse(),
        );
      }
    }
  }, [filteredColumn, isFilterAscending]);

  useEffect(() => {
    window.scrollTo(0, 0);
    AuthStore.updateLoadingFullScreen(true);

    if (UserStore.isHydrated) {
      const user_type = getDecodedToken()?.user_type;
      ReportsStore.setUsersAccount();
      if (
        PerformanceStore.famOrClient?.name === "fam" &&
        (user_type === "customer" || user_type === "employee")
      ) {
        ReportsStore.getFamilyClients("bill");
      } else if (
        (PerformanceStore.famOrClient?.name === "client" &&
          (user_type === "customer" || user_type === "employee")) ||
        user_type === "manager"
      ) {
        ReportsStore.setMapData([UserStore.userData]);
        ReportsStore.getSingleUsersAccount(
          PerformanceStore.famOrClient?.id,
          "bill",
        );
      }
      setTimePeriod("custome");
      setTimeout(() => {
        setTimePeriod("this_week");
      }, 500);
    }

    return () => {
      ReportsStore.resetBillsAndContracts();
    };
  }, [
    userHydrated,
    //  UserStore.isHydrated
  ]);

  useEffect(() => {
    const oneWeekDef = 518400000;
    const oneDayDef = 86400000;
    const asOfDate = getAsOfDate(UserStore.asOfDate);
    const as_of_date = asOfDate ? asOfDate : getCookie("asOfDate");
    const dateObjofAsOfDate = new Date(as_of_date);
    const forWeekObj = new Date(
      dateObjofAsOfDate.getTime() -
        (dateObjofAsOfDate.getDay() - 1) * oneDayDef,
    );
    const forPastWeekLast = new Date(forWeekObj.getTime() - oneDayDef);
    const forPastWeekFirst = new Date(forPastWeekLast.getTime() - oneWeekDef);
    let newTodate;
    let formattedTodate;
    let newFromdate;
    let formattedFromdate;

    if (!resetedFromDate && !resetedToDate) {
      setResetedFromDate(
        convertDateToObj(
          forWeekObj?.getFullYear() +
            "-" +
            padNumber(forWeekObj?.getMonth() + 1) +
            "-" +
            padNumber(forWeekObj?.getDate()),
        ),
      );
      setResetedToDate(convertDateToObj(as_of_date));
    }

    switch (timePeriod) {
      case "this_week":
        setFromDate(
          convertDateToObj(
            forWeekObj?.getFullYear() +
              "-" +
              padNumber(forWeekObj?.getMonth() + 1) +
              "-" +
              padNumber(forWeekObj?.getDate()),
          ),
        );
        setToDate(convertDateToObj(as_of_date));
        ReportsStore.setBillFromDate(
          convertDateToObj(
            forWeekObj?.getFullYear() +
              "-" +
              padNumber(forWeekObj?.getMonth() + 1) +
              "-" +
              padNumber(forWeekObj?.getDate()),
          ),
        );
        ReportsStore.setBillToDate(convertDateToObj(as_of_date));
        break;
      case "past_week":
        setFromDate(
          convertDateToObj(
            forPastWeekFirst?.getFullYear() +
              "-" +
              padNumber(forPastWeekFirst?.getMonth() + 1) +
              "-" +
              padNumber(forPastWeekFirst?.getDate()),
          ),
        );
        setToDate(
          convertDateToObj(
            forPastWeekLast?.getFullYear() +
              "-" +
              padNumber(forPastWeekLast?.getMonth() + 1) +
              "-" +
              padNumber(forPastWeekLast?.getDate()),
          ),
        );
        break;
      case "this_month":
        newFromdate = new Date(
          dateObjofAsOfDate.getFullYear(),
          dateObjofAsOfDate.getMonth(),
          1,
        );
        formattedFromdate =
          newFromdate?.getFullYear() +
          "-" +
          padNumber(newFromdate?.getMonth() + 1) +
          "-" +
          padNumber(newFromdate?.getDate());

        setFromDate(convertDateToObj(formattedFromdate));
        setToDate(convertDateToObj(as_of_date));
        break;
      case "past_month":
        newFromdate = new Date(
          dateObjofAsOfDate.getFullYear(),
          dateObjofAsOfDate.getMonth() - 1,
          1,
        );
        formattedFromdate =
          newFromdate?.getFullYear() +
          "-" +
          padNumber(newFromdate?.getMonth() + 1) +
          "-" +
          padNumber(newFromdate?.getDate());
        let dummyDateObj = new Date(as_of_date);
        let dummyTime = dummyDateObj?.setDate(1);
        newTodate = new Date(dummyTime - oneDayDif);
        formattedTodate =
          newTodate?.getFullYear() +
          "-" +
          padNumber(newTodate?.getMonth() + 1) +
          "-" +
          padNumber(newTodate?.getDate());

        setFromDate(convertDateToObj(formattedFromdate));
        setToDate(convertDateToObj(formattedTodate));
        break;
      default:
        break;
    }
    // eslint-disable-next-line
  }, [timePeriod]);

  useEffect(() => {
    if (ReportsStore.usersAccounts?.length) {
      onApplyFilter();
    }
    // eslint-disable-next-line
  }, [ReportsStore.usersAccounts]);

  const setAsOfDateToLocalStorage = () => {
    if (getAsOfDate(UserStore.asOfDate)) {
      setCookie("asOfDate", getAsOfDate(UserStore.asOfDate));
    }
  };
  useEffect(() => {
    trackEventWithScreen({ eventName: REPORTS_PAGE, screenName: BILLS });
    logEvents(REPORTS_PAGE, { screenName: BILLS });

    setAsOfDateToLocalStorage();
    return () => {
      ReportsStore.setAllAccountStatus(false);
    };
  }, []);

  const handleTimePeriodReset = () => {
    setFromDate(initialFromDate);
    setToDate(initialToDate);
  };

  useEffect(() => {
    if (datePickerModalOpen) {
      setInitialFromDate(fromDate);
      setInitialToDate(toDate);
    }
    // eslint-disable-next-line
  }, [datePickerModalOpen]);

  useEffect(() => {
    if (ReportsStore.usersAccounts.length !== 0) {
      let arr1 = ReportsStore.usersAccounts;
      const userID = getCookie("userid");
      const objectsToMove = arr1.filter(
        (obj) => obj.user_id === parseInt(userID, 10),
      );
      let updatedArr = [...objectsToMove];
      for (let i = 0; i < arr1.length; i++)
        if (!objectsToMove.some((el) => el.user_id === arr1[i].user_id))
          updatedArr.push(arr1[i]);
      setUserAccounts([...updatedArr]);
      ReportsStore.setSelectedAccount(updatedArr[0]);
    }
  }, [
    accounts?.length,
    //  ReportsStore.usersAccounts?.lengt
  ]);

  return (
    <Observer>
      {() => (
        <div>
          <PageTitle title={"Bills and Contract Notes Report"} />
          {AuthStore.isLoadingFullScreen ||
          !UserStore.isHydrated ||
          !ReportsStore.marginAllAccountsSuccess ? (
            <LoadingScreen />
          ) : (
            <>
              <Header type="reports" />
              <div className="reports_outer_main">
                <div className="bills_contract_notes_header content_hover">
                  <PageHeading
                    headingClass="head"
                    headingText="Bills and Contract Notes"
                  />
                  <BlueButton
                    text="Download Selected"
                    onClick={handleAllSelection}
                    customClass={"bills_btn"}
                  />
                </div>
                <div className="reports_yellow_container">
                  <div className="bill_contract_container">
                    <div className="bill_contract_first_container">
                      <RadioGroup
                        heading="Time Period"
                        name="time_period"
                        radioBtnArray={timePeriodBillsData}
                        handleChange={handleTimePeriodChange}
                        value={timePeriod}
                        radioBtnsPerRow={5}
                        groupId={"bills-and-contract-notes-time-period"}
                        groupName={"bills-and-contract-notes-group1"}
                      />
                      <DatePicker2
                        timePeriod={timePeriod}
                        fromDate={
                          fromDate
                            ? fromDate
                            : convertDateToObj(getCookie("asOfDate"))
                        }
                        toDate={
                          toDate
                            ? toDate
                            : convertDateToObj(getCookie("asOfDate"))
                        }
                        setFromDate={setFromDate}
                        setToDate={setToDate}
                        resetedFromDate={resetedFromDate}
                        resetedToDate={resetedToDate}
                        initialFromDate={initialFromDate}
                        initialToDate={initialToDate}
                        handleReset={handleTimePeriodReset}
                        // isActive={timePeriod === "custom"}
                        isActive={true}
                        open={datePickerModalOpen}
                        setOpen={() => {
                          handleTimePeriodChange("custom");
                          setDatePickerModalOpen(true);
                        }}
                        onClose={() => setDatePickerModalOpen(false)}
                      />
                    </div>
                    <div className="bill_contract_second_container">
                      <div className="radio_btn_group_wrapper">
                        <div className="report_type_radio">
                          <RadioGroup
                            heading="Report Type"
                            name="report_type"
                            radioBtnArray={reportTypeBillsData}
                            handleChange={handleReportTypeChange}
                            value={ReportsStore.selectedReportType}
                            radioBtnsPerRow={2}
                            groupId={"bills-and-contract-notes-report-type"}
                            groupName={"bills-and-contract-notes-group2"}
                          />
                        </div>
                        <div className="segment_radio">
                          <RadioGroup
                            heading="Segment"
                            name="segment"
                            radioBtnArray={segmentBillsData}
                            handleChange={handleSegmentChange}
                            value={ReportsStore.selectedSegment}
                            radioBtnsPerRow={4}
                            groupId={"bills-and-contract-notes-segment-type"}
                            groupName={"bills-and-contract-notes-group3"}
                          />
                        </div>
                      </div>
                      <div className="select_account_wrapper">
                        <DropdownWithOptions
                          heading={`${UserStore.selectedAccount?.accountName}`}
                          headingValue={UserStore.selectedAccount}
                          setHeadingValue={(data) => {
                            ReportsStore.setSelectedAccount(data);
                          }}
                          position={{ top: "56px", left: "0px" }}
                          // showPopup={
                          //   !(ReportsStore.usersAccounts?.length === 1)
                          // }
                          showArrow={false}
                          disabledPopup={
                            ReportsStore.usersAccounts.length === 1
                          }
                          // isDisabled={!UserStore.selectedAccount?.accountName}
                          popupClassName={{
                            wrapperClass: "popup_menu_container",
                            dropDownContainerClass: "all_accounts_dropdown",
                            popupMenuClass: "reports_select_account_popup_menu",
                          }}
                          restrictHover={true}
                          OPTIONS={userAccounts}
                          accessibilityValues={{
                            buttonId: "",
                            ariaHaspopup: "listbox",
                            ariaControls: "accounts-options",
                            ariaLabel: "Accounts Selection",
                          }}
                          dataKey="accountCode"
                          dataValueKey="accountName"
                        />
                      </div>
                    </div>
                  </div>
                  <ApplyFilter
                    customCss="reusable-button"
                    onApplyFilter={onApplyFilter}
                    onClearFilter={onClearFilter}
                  />
                </div>
                {ReportsStore.tableDataLoader ? (
                  <div className="report_table_loader">
                    <div className="report_loader_wrapper">
                      <img
                        className="loading_gif"
                        src={loaderGIF}
                        alt="loading..."
                      />
                    </div>
                  </div>
                ) : (
                  <>
                    <div
                      style={{
                        backgroundColor: "#fff",
                        height: 12,
                        width: "100%",
                        position: "sticky",
                        top: 0,
                      }}
                    />
                    {ReportsStore.contractnBillData.length !== 0 ? (
                      <Table
                        data={vertualRows}
                        columns={columns2}
                        tableClass="valuation_report_table grey-border-table"
                        tableHeaderClass="header-box-shadow"
                        sortKey={filteredColumn}
                        isAscending={isFilterAscending}
                        handleSort={(key) => handleSort(key)}
                      />
                    ) : (
                      <div className="empty_state_for_valuation">
                        <EmptyDerivatives
                          image={noData}
                          message="You do not have any records to display"
                        />
                      </div>
                    )}
                  </>
                )}
              </div>
            </>
          )}
        </div>
      )}
    </Observer>
  );
};

export default observer(BillsContractNotes);
